import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/core';
import { inject, NgModule } from '@angular/core';
import { provideNamedApollo } from 'apollo-angular';
import {
  HttpHeaders,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { environment } from '../../../environments/environment';

@NgModule({
  providers: [
    provideNamedApollo(() => {
      const httpLink = inject(HttpLink);
      return {
        GatewayGraphQL: {
          cache: new InMemoryCache(),
          link: httpLink.create({
            uri: environment.graphql.gateway.url,
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
            }),
          }),
        },
        RBSGraphQL: {
          cache: new InMemoryCache(),
          link: httpLink.create({
            uri: environment.graphql.rbs.url,
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
            }),
          }),
        },
        ProjectGraphQL: {
          cache: new InMemoryCache(),
          link: httpLink.create({
            uri: environment.graphql.project.url,
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
            }),
          }),
        },
        WageGraphQL: {
          cache: new InMemoryCache(),
          link: httpLink.create({
            uri: environment.graphql.wageData.url,
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
            }),
          }),
        },
        EmailMessagingGraphql: {
          cache: new InMemoryCache(),
          link: httpLink.create({
            uri: environment.graphql.email.url,
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
            }),
          }),
        },
      };
    }),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class GraphQLModule {}
